import { Col, Row } from 'antd'
import { useNavigate } from 'react-router-dom'
import { ContentCard } from '../../components/ContentCard'
import { FadeIn } from '../../components/FadeIn'

export const HomePage = () => {
  const navigate = useNavigate()

  return (
    <FadeIn>
      <div style={{ padding: 24 }}>
        <Row justify={'center'} gutter={[24, 24]}>
          <Col sm={12} xs={24}>
            <ContentCard title="Characters" onClick={() => navigate('/character')}>
              <p>
                Select a character from your roster to check its stats and play an adventure with
                them
              </p>
            </ContentCard>
          </Col>
          <Col sm={12} xs={24}>
            <ContentCard title="Adventures" onClick={() => navigate('/adventure')}>
              <p>
                As a Dungeon Master, see information of your adventures and all the players on each
                one of them
              </p>
            </ContentCard>
          </Col>
        </Row>
      </div>
    </FadeIn>
  )
}
